import React from "react";
import { Form, Button, Input, Select, DatePicker } from "antd";

import "./ShippersFilter.scss";
import { ReactSVG } from "react-svg";
const { RangePicker } = DatePicker;
const ShipperFilterForm = ({
	filterSubmit,
	form,
	resetForm,
	admins,
	onExportShippersClick,
}) => {
	return (
		<div className="shippers-filter-form-container">
			<Form form={form} onFinish={filterSubmit} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item name="orderId">
						<Input placeholder="Order ID" />
					</Form.Item>
					<Form.Item name="adminId">
						<Select placeholder="Shipper email">
							<Select.Option value="">Select email</Select.Option>
							{admins &&
								admins.map((admin) => (
									<Select.Option key={admin.id} value={admin.id}>
										{admin.email}
									</Select.Option>
								))}
						</Select>
					</Form.Item>

					<Form.Item name="date_range">
						<RangePicker />
					</Form.Item>
					{/* <Form.Item name="today" valuePropName="checked">
						<Checkbox>Filter by Today?</Checkbox>
					</Form.Item> */}
				</div>
				<div className="form-actions">
					<Button type="text" onClick={resetForm} className="btn btn-secondary">
						Reset
					</Button>
					<Button
						type="text"
						className="btn btn-secondary btn-export"
						onClick={onExportShippersClick}
					>
						Download
						<ReactSVG src="/icons/file-download.svg" />
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						Search
						<ReactSVG src="/icons/search.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default ShipperFilterForm;
